var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('users-list',{attrs:{"registration-fields":_vm.fields,"edit-fields":_vm.fields,"role-query":"Farmer","add-request-path":_vm.requestUrls.farmer.add,"edit-request-path":_vm.requestUrls.farmer.edit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }